module.exports = __webpack_public_path__ + "img/3-2.fa65c9a4.jpg";